/* eslint-disable no-undef */

import { getChatMessages, Upload } from '../../../../apiclient/resources/lead';
import * as actions from './actions';
import * as utils from './utils';
import { UploadTrack } from '../../../../services/gtmServices';

const fetchMessages = (contactId, leadName, scrollDownHandle, t) => dispatch => {
  dispatch(actions.fetchMessages(contactId));
  getChatMessages(contactId).then(({ error, data }) => {
    if (!error) {
      utils.setGroupMessages(data, t, leadName)(groupMessages => {
        dispatch(actions.fetchMessagesSucceeded({ messages: [...data], groupMessages, leadName }));
        setTimeout(() => scrollDownHandle(), 1);
      });
    } else {
      dispatch(actions.fetchMessagesFailed(error));
    }
  });
};

const fetchAddFile = form => dispatch => {
  dispatch(actions.addFile());
  Upload(form).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.addFileSuceeded(data));
      UploadTrack('upload_file');
    } else {
      dispatch(actions.errorUpload([]));
    }
  });
};

const fetchRemoveFile = data => dispatch => {
  dispatch(actions.removeFile(data));
};

const fetchRevertError = data => dispatch => {
  dispatch(actions.revertError());
};

const displaySnackbar = data => dispatch => {
  dispatch(
    actions.showSnackBar({
      message: data.message,
      show: true,
      isError: true
    })
  );
};

const NotdisplaySnackbar = () => dispatch => {
  dispatch(
    actions.showSnackBar({
      message: 'error',
      show: false,
      isError: true
    })
  );
};

const fetchResetFileState = () => dispatch => {
  dispatch(actions.resetFileState({}));
};

const fetchShowModal = () => dispatch => {
  dispatch(actions.showModal({}));
};

export const { addMessage, addFile, setquicklyTranslate, addMessageSucceded } = actions;

export {
  fetchMessages,
  fetchAddFile,
  displaySnackbar,
  NotdisplaySnackbar,
  fetchRemoveFile,
  fetchRevertError,
  fetchResetFileState,
  fetchShowModal
};
